import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: () => import('@/views/Index.vue'),
        children: [
            { path: '', redirect: 'plist' },
            {
                path: 'SysStop',
                name: 'SysStop',
                component: () => import('@/views/SysStop.vue')
            },
            {
                path: 'plist',
                name: 'RecPlanList',
                component: () => import('@/views/PlanList.vue')
            },
            {
                path: 'pnote',
                name: 'RecPlanNote',
                component: () => import('@/views/PlanNote.vue')
            },
            {
                path: 'posts',
                name: 'RecPostList',
                component: () => import('@/views/PostList.vue')
            },
            {
                path: 'preg',
                name: 'RecPostReg',
                component: () => import('@/views/PostReg.vue')
            },
            {
                path: 'result',
                name: 'RecRegResult',
                component: () => import('@/views/RegResult.vue')
            },
            {
                path: 'getBMXH',
                name: 'getBMXH',
                component: () => import('@/views/GetBMXH.vue')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            //此处意思 即若回退页面，返回savedPosition，且页面不置顶
            return savedPosition
        } else {
            //此处意思 若页面跳转新页面，则页面置顶
            return { x: 0, y: 0, behavior: 'smooth' }
        }
    }
})

export default router
